<template>
  <v-popup closeable @after-close="$emit('close')" @close="$emit('close')">
    <div class="popup-close" @click="$emit('close')">
      <img src="~@/assets/icons/icon-popup-close.svg" />
    </div>
    <form
      class="mt-40"
      @keydown.enter.prevent
      @dragenter.stop.prevent="dragging = true"
      @dragover.stop.prevent="dragging = true"
      @dragend.prevent.stop="dragging = false"
      @dragleave.stop.prevent="dragging = false"
      @drop.stop.prevent="handleFileUpload($event.dataTransfer.files)"
    >
      <h2 class="upload-title">{{ $t("data-upload.title") }}</h2>
      <p class="upload-desc" v-html="marked($t('data-upload.description'))"></p>
      <div class="upload-inner">
        <div
          class="files-dd"
          v-if="this.files.length < this.maxFiles"
          :class="{
            'files-dd--active': dragging,
          }"
          @click="$refs.fileInput.click()"
        >
          <span v-if="this.files.length < this.maxFiles">
            <p>{{ $t("data-upload.files-upload-text") }}</p>
            <span class="folder">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.25 19.9199H20.75C21.3023 19.9199 21.75 19.4722 21.75 18.9199V8.41992C21.75 8.14378 21.5261 7.91992 21.25 7.91992H6.25C5.97386 7.91992 5.75 8.14378 5.75 8.41992V13.9199"
                  stroke="#023970"
                  stroke-linecap="square"
                />
                <path
                  d="M5.75 13.9199V18.4199C5.75 19.2484 5.07843 19.9199 4.25 19.9199V19.9199C3.42157 19.9199 2.75 19.2484 2.75 18.4199V4.41995C2.75 4.1438 2.97386 3.91995 3.25 3.91995H8.13C8.51016 3.9173 8.85893 4.13044 9.03 4.46995L9.47 5.36995C9.64107 5.70945 9.98984 5.92259 10.37 5.91995H19.25C19.5261 5.91995 19.75 6.1438 19.75 6.41995V7.91995"
                  stroke="#023970"
                  stroke-linecap="square"
                />
              </svg>

              <p>{{ $t("data-upload.files-upload-button") }}</p>
            </span>
          </span>
          <span v-else>
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M39.5 43.8398H9.5V5.83984H31.5L39.5 13.8398V43.8398V43.8398Z"
                stroke="black"
                stroke-width="2"
                stroke-linecap="square"
              />
              <path d="M31.5 5.83984V13.8398H39.5" stroke="black" stroke-width="2" />
              <path d="M15.5 19.8398H31.5" stroke="black" stroke-width="2" stroke-linecap="square" />
              <path d="M15.5 23.8398H31.5" stroke="black" stroke-width="2" stroke-linecap="square" />
              <path d="M15.5 27.8398H31.5" stroke="black" stroke-width="2" stroke-linecap="square" />
              <path d="M15.5 31.8398H24.5" stroke="black" stroke-width="2" stroke-linecap="square" />
            </svg>
            <p>{{ $t("data-upload.files-upload-max") }}</p>
          </span>
        </div>
        <div class="files-dd--disable" v-if="this.files.length == this.maxFiles">
          <span v-if="this.files.length < this.maxFiles">
            <p>{{ $t("data-upload.files-upload-text") }}</p>
            <span class="folder">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.25 19.9199H20.75C21.3023 19.9199 21.75 19.4722 21.75 18.9199V8.41992C21.75 8.14378 21.5261 7.91992 21.25 7.91992H6.25C5.97386 7.91992 5.75 8.14378 5.75 8.41992V13.9199"
                  stroke="#023970"
                  stroke-linecap="square"
                />
                <path
                  d="M5.75 13.9199V18.4199C5.75 19.2484 5.07843 19.9199 4.25 19.9199V19.9199C3.42157 19.9199 2.75 19.2484 2.75 18.4199V4.41995C2.75 4.1438 2.97386 3.91995 3.25 3.91995H8.13C8.51016 3.9173 8.85893 4.13044 9.03 4.46995L9.47 5.36995C9.64107 5.70945 9.98984 5.92259 10.37 5.91995H19.25C19.5261 5.91995 19.75 6.1438 19.75 6.41995V7.91995"
                  stroke="#023970"
                  stroke-linecap="square"
                />
              </svg>

              <p>{{ $t("data-upload.files-upload-button") }}</p>
            </span>
          </span>
          <span v-else>
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M39.5 43.8398H9.5V5.83984H31.5L39.5 13.8398V43.8398V43.8398Z"
                stroke="black"
                stroke-width="2"
                stroke-linecap="square"
              />
              <path d="M31.5 5.83984V13.8398H39.5" stroke="black" stroke-width="2" />
              <path d="M15.5 19.8398H31.5" stroke="black" stroke-width="2" stroke-linecap="square" />
              <path d="M15.5 23.8398H31.5" stroke="black" stroke-width="2" stroke-linecap="square" />
              <path d="M15.5 27.8398H31.5" stroke="black" stroke-width="2" stroke-linecap="square" />
              <path d="M15.5 31.8398H24.5" stroke="black" stroke-width="2" stroke-linecap="square" />
            </svg>
            <p>{{ $t("data-upload.files-upload-max") }}</p>
          </span>
        </div>
        <div class="file-table-scroll" v-if="filesData.length">
          <table class="files-table">
            <tr>
              <th class="column column--file-name">
                <p>{{ $t("data-upload.files-name") }}</p>
              </th>
              <!-- <th class="column column--file-size">File Size</th> -->
              <!-- <th class="column column--file-details">
                <p>{{ $t("data-upload.files-details") }}</p>
              </th> -->
            </tr>
            <tr v-for="(file, index) in filesData" :key="file.name">
              <td
                class="column column--file-name list-cell list-cell--file-name"
                :class="{
                  'text-secondary-accent': file.status === 'progress',
                  'text-green': file.status === 'success',
                  'text-red': file.status === 'error',
                }"
              >
                <div class="file-name-inner">
                  <span
                    class="file-status"
                    :class="{
                      'file-status--progress': file.status === 'progress',
                      'file-status--success': file.status === 'success',
                      'file-status--error': file.status === 'error',
                    }"
                  />
                  {{ file.name }}
                  <span class="file-close" @click="removeFile(index)" />
                </div>
              </td>
              <!-- <td
                class="column column--file-size list-cell"
                :class="{
                  'text-red':
                    file.status === 'error' && file.errorType === 'file-size'
                }"
              >
                {{ humanFileSize(file.size) }}
              </td> -->
              <td class="column column--description list-cell list-cell-input-parent">
                <v-select
                  v-if="locations.length > 1"
                  class="select-width1"
                  v-model="file.locationId"
                  :options="locations"
                  value-property="id"
                  label-translation-property="name"
                />
              </td>
            </tr>
          </table>
        </div>
      </div>
    </form>
    <div class="footer">
      <input
        type="file"
        ref="fileInput"
        accept=".dwg,.pdf,.xlsx,.jpg,.gif,.png"
        multiple
        @change="handleFileUpload($event.target.files)"
        class="hidden"
      />

      <v-button
        accent
        :loading="uploadInProgress"
        class="button-upload"
        :disabled="!filesData.length || filesData.some((i) => i.status === 'error')"
        @click="submitFiles"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.5 8.08984L10.5 17.0898L7.5 14.0898" stroke="#999999" />
          <rect x="2.5" y="3.08984" width="19" height="19" rx="9.5" stroke="#999999" stroke-linecap="square" />
        </svg>

        {{ $t("data-upload.upload") }}
      </v-button>
    </div>

    <div
      v-if="filesData.some((i) => i.status === 'error' && i.errorType === 'file-size')"
      class="message-error"
      v-html="$t('data-upload.size-error')"
    />

    <div
      v-if="filesData.some((i) => i.status === 'error' && i.errorType === 'file-type')"
      class="message-error"
      v-html="$t('data-upload.file-type-error')"
    />

    <div
      v-if="filesData.some((i) => i.status === 'error' && i.errorType === 'upload-error')"
      class="message-error"
      v-html="$t('data-upload.upload-error')"
    />
  </v-popup>
</template>

<script>
import { VPopup, VButton, VSelect } from "shared";
import { marked } from "marked";
// import * as DocumentsDAO from "@/dao/documents-dao";
// import * as MarkdownUtils from "@/utils/MarkdownUtils";

export default {
  components: {
    VPopup,
    VButton,
    VSelect,
  },
  props: {
    locations: {
      type: Array,
      default: () => [],
    },
    chosenLocation: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      files: [],
      filesData: [],
      dragging: false,
      uploadInProgress: false,
      maxFiles: 5,
      maxSummaryFileSize: 52428800,
    };
  },
  methods: {
    handleFileUpload(files) {
      for (let i = 0; i < files.length; i += 1) {
        const file = files[i];

        if (
          !this.files.find((f) => f.name === file.name && f.size === file.size) &&
          this.files.length < this.maxFiles
        ) {
          const summaryFileSize = this.files.reduce((acc, f) => acc + f.size, 0);
          this.files.push(file);
          const isFileTooBig = summaryFileSize + file.size > this.maxSummaryFileSize;
          const isRightFormat = [
            "dwg",
            "pdf",
            "vnd.openxmlformats-officedocument.spreadsheetml.sheet", // xlsx
            "jpg",
            "jpeg",
            "gif",
            "png",
          ].some((format) => file.type.endsWith(format));
          const fileDataItem = {
            name: file.name,
            status: isFileTooBig || !isRightFormat ? "error" : "success",
            errorType: isFileTooBig ? "file-size" : "file-type",
            size: file.size,
            locationId: this.chosenLocation || null,
          };
          this.filesData.push(fileDataItem);
        }
      }
    },
    humanFileSize(size) {
      const i = Math.floor(Math.log(size) / Math.log(1024));
      return `${(size / 1024 ** i).toFixed(2) * 1} ${["B", "kB", "MB", "GB", "TB"][i]}`;
    },
    removeFile(index) {
      this.files.splice(index, 1);
      this.filesData.splice(index, 1);
      let fileSizeCounter = 0;
      this.filesData = this.filesData.map((fData) => {
        fileSizeCounter += fData.size;
        const isFileTooBig = fileSizeCounter > this.maxSummaryFileSize;
        return {
          ...fData,
          status: isFileTooBig ? "error" : "success",
          errorType: isFileTooBig ? "file-size" : "file-type",
        };
      });
    },
    async submitFiles() {
      this.uploadInProgress = true;
      const formData = new FormData();

      formData.append(
        "message",
        JSON.stringify(
          this.filesData.map((file) => ({
            filename: file.name,
            locationId: file.locationId,
          }))
        )
      );

      for (const file of this.files) {
        formData.append("files[]", file);
      }

      try {
        // await DocumentsDAO.uploadFiles({
        //   formData
        // });
        // eslint-disable-next-line no-param-reassign
        this.filesData.forEach((f) => {
          f.status = "success";
        });
        this.$emit("close");
        this.$emit("success", {
          files: this.files,
        });
      } catch (e) {
        this.filesData.forEach((f) => {
          f.status = "error"; // eslint-disable-line no-param-reassign
          f.errorType = "upload-error"; // eslint-disable-line no-param-reassign
        });
      }
      this.uploadInProgress = false;
    },
    marked,
  },
  async created() {
    this.loading = true;
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";
::-webkit-scrollbar {
  width: 7px;
}
::-webkit-scrollbar-track {
  background: transparent;
}
::-webkit-scrollbar-thumb {
  background: #d8d8d8;
  border-radius: 10px;
  transition: all 0.2s;
}
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
::v-deep .popup__container {
  width: 712px;
  min-width: 712px;
  overflow: visible;
  padding: 70px 64px 32px 64px;
}

::v-deep .popup__header {
  padding: 32px;
  min-height: 0 !important;
}

::v-deep .popup__content {
  padding: 0 64px 0 !important;
}

::v-deep .popup__title {
  font-size: 24px !important;
  color: $color-black !important;
  font-weight: 400 !important;
}

.files-table {
  width: 100%;
  text-align: left;
  border-spacing: 8px;

  th {
    color: #999;
    font-size: 13px;
    font-weight: 700;
    padding-bottom: 5px;
  }
}

.files-dd {
  padding: 30px 20px;
  margin-bottom: 30px;
  text-align: center;
  cursor: pointer;
  background: #fbfbfb;
  border: 1px solid #e4e4e4;
  border-radius: 3px;
  height: 448px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 13px;
  &--active {
    border: 3px solid #023970;
  }
  &--disable {
    pointer-events: none;
  }
}
.files-dd--disable {
  padding: 30px 20px;
  margin-bottom: 30px;
  text-align: center;
  background: #fbfbfb;
  border: 1px solid #e4e4e4;
  border-radius: 3px;
  height: 448px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 13px;
}
.column {
  &--file-name {
    width: 50%;
    position: relative;
    padding: 0 !important;
  }
  &--file-size {
    width: 20%;
  }
  &--file-details {
    width: 50%;
    padding-left: 8px;
  }
  &--description {
    width: 50%;
    padding-left: 8px !important;
  }
}

.list-cell {
  //border: 1px solid $color-grey_3;
  //background: $color-grey_5;
  padding: 12px;
  font-size: 13px;
  padding-bottom: 8px !important;
}

.file-name-inner {
  background: #fbfbfb;
  border: 1px solid #e4e4e4;
  border-radius: 3px;
  height: 40px;
  padding: 8px 30px 8px 8px;
  display: inline-flex;
  vertical-align: middle;
  align-items: center;
  width: 100%;
  margin-top: -2px;
}
.list-cell-input-parent {
  padding: 0;
}

.list-cell-input {
  border: none !important;
  outline: none !important;
  color: #333333;
  background: none;
  padding: 12px;
  width: 100%;
}

.file-status {
  width: 35px;
  height: 25px;

  &--success {
    background: url("~@/assets/icons/media-upload-icon-success.svg") center no-repeat;
  }

  &--error {
    background: url("~@/assets/icons/media-upload-icon-error.svg") center no-repeat;
  }

  &--progress {
    position: relative;
    &::after {
      background: url("~@/assets/icons/media-upload-icon-progress.svg") center no-repeat;
      width: 25px;
      height: 25px;
      position: absolute;
      left: 2px;
      top: 0px;

      animation: rotate 1s infinite;
      content: "";
    }
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0);
  }
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0);
  }
}
.file-close {
  background: url("~@/assets/icons/icon-close-black.svg") center no-repeat;
  width: 24px;
  height: 24px;
  position: absolute;
  right: 5px;
  top: 8px;
  cursor: pointer;
}

.footer {
  text-align: right;
  margin-top: 30px;
}

.message-error {
  position: absolute;
  bottom: -50px;
  left: 0;
  right: 0;
  height: 56px;
  line-height: 56px;
  text-align: center;
  background: #c87817;
  color: #fff;
  font-size: 13px;
  &::before {
    background: url("~@/assets/icons/icon-error-upload-white.svg");
    width: 24px;
    height: 24px;
    display: inline-block;
    vertical-align: middle;
    content: "";
    margin: -3px 14px 0 0;
  }
}
.upload-title {
  font-size: 24px;
  line-height: 26px;
  letter-spacing: 0.8px;
}
.upload-desc {
  font-size: 13px;
  line-height: 14px;
  letter-spacing: 0.464286px;
  margin: 16px 0;
  color: #333333;
}
.hidden {
  display: none;
}
.button-upload {
  padding-left: 20px;
  padding-right: 20px;
  background: #d15421;
  color: #fff;
  svg {
    margin: -2px 8px 0 -2px;
    * {
      stroke: #fff;
    }
  }
  &:disabled {
    color: #999999;
    background: #e4e4e4;
    svg {
      * {
        fill: inherit;
        stroke: #999;
      }
    }
  }
}
.select-width1 {
  width: 100%;
}
.upload-inner {
  height: 400px;
  display: flex;
  flex-direction: column;
  .file-table-scroll {
    margin-top: 24px;
  }
  .files-dd {
    height: 100%;
    max-height: 100% !important;
    margin-bottom: 0;
    flex-wrap: wrap;
    p {
      width: 100%;
      font-size: 13px;
      line-height: 16px;
    }
    .folder {
      font-weight: bold;
      font-size: 13px;
      line-height: 14px;
      letter-spacing: 1.25px;
      display: flex;
      align-items: center;
      margin-top: 20px;
      svg {
        margin: -2px 10px 0 0;
      }

      /* Secondary Accent Colour */

      color: #023970;
    }
  }
}
.popup-close {
  position: absolute;
  right: 24px;
  top: 24px;
  cursor: pointer;
}
</style>
